package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.icons.FixedGps
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.main.MainScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.title_map_admin
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteMapAdmin : RouteParameterTo

object RouterMapAdmin : RouterNoParameters<RouteMapAdmin>(RouteMapAdmin::class) {
    override fun routeFrom(parameters: RouteMapAdmin) = "/map/admin"

    @Composable
    override fun Show(parameters: RouteMapAdmin) {
        RouteMapAdminImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteMapAdmin,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    /** Opens the map without removing the current screen from the stack, so that "back" returns to it. */
    fun navigateToKeepingBack() = NavigateTo(
        route = RouteMapAdmin,
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteMapAdmin

    override fun isMatching(route: String) = route == "/map/admin"

    override fun navigateFrom(path: String) = RouteMapAdmin
}

class RouteMapAdminImpl : Route<RouteMapAdmin>(
    route = "/map/admin",
    params = RouteMapAdmin,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()
        val apiAdmin = state.apiProvider?.apiAdmin

        if (apiAdmin == null) {
            LaunchedEffect(Unit) { appModel.leaveAdminRoute() }
            return
        }

        LaunchedEffect(Unit) {
            appModel.ensureAdminMode()
            appModel.markCurrentRoute(RouteMapAdmin)
            onEntryIsActive(appModel, emptyList())
        }

        MainScreen(
            Modifier.fillMaxSize(),
            appModel,
            apiAdmin,
            true
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.title_map_admin,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.FixedGps,
                    onClick = { appModel.show(RouterEstimatesAdmin.navigateToKeepingBack()) }
                )
            )
        )
    }
}
